import {
    TEAM_REQUEST_LIST_REQUEST,
    TEAM_REQUEST_LIST_SUCCESS,
    TEAM_REQUEST_LIST_FAILURE
} from "../../../actions/admin/constants"

const initialState = {
    data: null,
    loading: false,
    error: null,
    type: null,
};

const TeamListReducer = (state = initialState, action) => {
    switch (action.type) {
        case TEAM_REQUEST_LIST_REQUEST:
            return {
                ...state,
                loading: true,
                data: null,
                error: null,
                type: action.fetchType,
            };
        case TEAM_REQUEST_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                type: action.fetchType,
                error: null,
            };
        case TEAM_REQUEST_LIST_FAILURE:
            return {
                ...state,
                loading: false,
                error: action.payload,
                type: action.fetchType,
                data: null,
            };
        default:
            return state;
    }
};

export default TeamListReducer;
